/** The history table's columns, by what they hold. */
export type ImportHistoryColumnId =
    | 'date'
    | 'file'
    | 'rows'
    | 'products'
    | 'units'
    | 'stockValue'
    | 'user'
    | 'status';

/**
 * From `sm` up, one column per figure (canvas board 10b, plus status). On a
 * phone, two: the file, with the date, who, the figures and the status
 * folded under it, and the stock value.
 */
export const importHistoryColumnsOf = (
    isNarrow: boolean,
): readonly ImportHistoryColumnId[] =>
    isNarrow
        ? ['file', 'stockValue']
        : [
              'date',
              'file',
              'rows',
              'products',
              'units',
              'stockValue',
              'user',
              'status',
          ];

/** Columns of figures, right-aligned in the header and the rows. */
export const isNumericColumn = (id: ImportHistoryColumnId): boolean =>
    id === 'rows' || id === 'products' || id === 'units' || id === 'stockValue';

export const IMPORT_HISTORY_COLUMN_LABEL_KEY = {
    date: 'catalogImport.branchImport.history.columns.date',
    file: 'catalogImport.branchImport.history.columns.file',
    rows: 'catalogImport.branchImport.history.columns.rows',
    products: 'catalogImport.branchImport.history.columns.products',
    units: 'catalogImport.branchImport.history.columns.units',
    stockValue: 'catalogImport.branchImport.history.columns.stockValue',
    user: 'catalogImport.branchImport.history.columns.user',
    status: 'catalogImport.branchImport.history.columns.status',
} as const satisfies Record<ImportHistoryColumnId, string>;

/** When an import ran or was undone, in the display zone (as Done prints it). */
export const IMPORT_HISTORY_DATE_FORMAT = 'DD/MM/YYYY HH:mm';
